import { ICompoundTagsProps } from "./ICompoundTagsProps";
import { Tag } from "@snpjs/core";
import styles from "./CompoundTags.module.scss";

export function CompoundTags<T>(props: ICompoundTagsProps<T>) {
  const items = props.objects.map((object, index) => {
    const name = props.getName(object);
    const value = props.getValue(object);
    return (
      <>
        {value ? (
          <Tag key={index} fill={true} intent="primary">
            {name}: {value}
          </Tag>
        ) : (
          <Tag key={index} fill={true} intent="primary">
            {name}
          </Tag>
        )}
      </>
    );
  });

  return (
    <>
      <div className={styles.gridContainer}>{items}</div>
    </>
  );
}
